import React from 'react';
import html from 'assets/icons/html-5.png';
import css from 'assets/icons/css-3.png';
import js from 'assets/icons/js.png';
import react from 'assets/icons/atom.png';
import sass from 'assets/icons/sass.png';
import styles from './Skills.module.scss';

const Skills = () => {
    return (
        <ul className={styles.skills}>
            <li>    
                <p>Tech Stack</p>
            </li> 
            <li>    
                <img src={html} alt="icon"/>
            </li>    
            <li>    
                <img src={css} alt="icon"/>
            </li>
            <li>    
                <img src={js} alt="icon"/>
            </li> 
            <li>    
                <img src={react} alt="icon"/>
            </li> 
            <li>    
                <img src={sass} alt="icon"/>
            </li>
        </ul>

    );
}

export default Skills;
